import { useEffect, useRef } from 'react'

export const usePopupContainer = (dataTestId: string) => {
	const divRef = useRef<HTMLDivElement | null>(null)
	useEffect(() => {
		divRef.current = document.createElement('div')
		divRef.current.setAttribute('data-testid', dataTestId)
		document.body.appendChild(divRef.current)
		return () => {
			divRef.current &&
				document.body.contains(divRef.current) &&
				document.body.removeChild(divRef.current)
		}
	}, [dataTestId])
	const getPopupContainer = () => (divRef.current ? divRef.current : document.body)
	return getPopupContainer
}
